var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "ul",
        {
          staticClass:
            "mx-0 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 my-6",
        },
        [_vm._t("default")],
        2
      ),
      _vm._t("pagination"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }